/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import * as React from "react";

const Information: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 34 34" enableBackground="new 0 0 34 34" xmlSpace="preserve">
<path fillRule="evenodd" clipRule="evenodd" fill="currentColor" d="M17,0.3C7.8,0.3,0.3,7.8,0.3,17S7.8,33.7,17,33.7
	S33.7,26.2,33.7,17S26.2,0.3,17,0.3z M18.7,25.3h-3.3v-10h3.3V25.3z M18.7,12h-3.3V8.7h3.3V12z"/>
</svg>;
};

export default React.memo(Information);
